import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FAQSection() {
  const [openIds, setOpenIds] = useState<number[]>([1]);

  const toggle = (id: number) => {
    setOpenIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  return (
    <section id="faq" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-600 bg-secondary-100 rounded-full mb-4">
            帮助中心
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">关于吃瓜官网的常见疑问解答</p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => {
            const isOpen = openIds.includes(item.id);
            return (
              <div
                key={item.id}
                className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => toggle(item.id)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                >
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                    {item.question}
                  </h3>
                  <i
                    className={`ri-arrow-down-s-line text-lg text-foreground-400 transition-transform duration-300 shrink-0 ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}